







































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import tooltip from '@/directives/tooltip'

@Component({
  directives: {
    tooltip,
  },
})
export default class CopyButton extends Vue {
  $refs: {
    innerInput: HTMLInputElement
  }

  @Prop({ required: true })
  buttonLabel: string

  @Prop({ required: true })
  tooltipLabel: string

  @Prop({ required: true })
  valueToCopy: string

  private disabled: boolean = false

  private showTooltip: boolean = true

  get tooltipOption(): string | object {
    if (this.showTooltip) {
      return {
        title: this.tooltipLabel,
        trigger: 'click',
      }
    }

    return 'hide'
  }

  onClick() {
    if (this.disabled) {
      return
    }

    // 連打でチラつくのを避けるため、バルーン表示中はボタンを無効化する
    this.disabled = true

    const inputElement = this.$refs.innerInput

    this.copyToClipBoard(inputElement)

    // tslint:disable-next-line:no-magic-numbers
    setTimeout(this.hideTooltip, 2000)
  }

  beforeDestroy() {
    // コンポーネント破棄時にバルーンが残り続けるのを回避
    this.hideTooltip()
  }

  private copyToClipBoard(input: HTMLInputElement): void {
    const selection = window.getSelection()
    if (selection) selection.removeAllRanges()
    input.focus()
    input.setSelectionRange(0, this.valueToCopy.length)
    document.execCommand('copy')
    input.blur()
    if (selection) selection.removeAllRanges()
  }

  private hideTooltip() {
    // バルーンを非表示にする
    this.showTooltip = false
    this.disabled = false

    // 少し間をおいてから、またクリックに反応させる
    // tslint:disable-next-line:no-magic-numbers
    setTimeout(() => { this.showTooltip = true }, 100)
  }
}
